
<div data-cy="student-tabs-wrapper" class="tabs-wrapper" *ngIf="isStudent">
    <div class="tab-container">
        <div class="tab" (click)="toggleSidebar()">
            <i class="msi-apps"></i>
        </div>
        <a routerLink="/statistics" class="tab" routerLinkActive="tab--active">
            <i class="msi-chart"></i>
        </a>
        <a routerLink="/exercises" class="center-tab" routerLinkActive="center-tab--active">
            <i class="msi-file-check"></i>
        </a>
        @if (canViewRating) {
          <a data-cy="student-rating-tab" routerLink="/rating" class="tab" routerLinkActive="tab--active">
            <i class="msi-star"></i>
          </a>
        } @else {
          <a data-cy="student-profile-tab" routerLink="/profile" class="tab" routerLinkActive="tab--active">
            <i class="msi-user"></i>
          </a>
        }
        <a routerLink="/multiplayer" class="tab" routerLinkActive="tab--active">
            <i class="msi-gamepad"></i>
        </a>
    </div>

    <svg class="divider" width="141" height="58" viewBox="0 0 141 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6982 0C24.9058 0 31.3838 6.69336 33.3994 14.6484C37.4604 30.6836 48.4609 45.5547 70.5 45.9902C92.5391 45.5547 103.54 30.6836 107.601 14.6484C109.616 6.69336 116.094 0 124.302 0H140.5V58H70.5H0.5V0H16.6982Z" fill="#9485E9"/>
    </svg>
</div>


<div data-cy="teacher-tabs-wrapper" class="tabs-wrapper" *ngIf="isTeacher">
    <div class="tab-container">
        <div class="tab" (click)="toggleSidebar()">
            <i class="msi-apps"></i>
        </div>
        <a routerLink="/groups" class="tab" routerLinkActive="tab--active">
            <i class="msi-users"></i>
        </a>
        <a routerLink="/homeworks" class="center-tab" routerLinkActive="center-tab--active">
            <i class="msi-file-check"></i>
        </a>
        <a routerLink="/students" class="tab" routerLinkActive="tab--active">
            <i class="msi-friends"></i>
        </a>
        <a routerLink="/profile" class="tab" routerLinkActive="tab--active">
            <i class="msi-user"></i>
        </a>
    </div>

    <svg class="divider" width="141" height="58" viewBox="0 0 141 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6982 0C24.9058 0 31.3838 6.69336 33.3994 14.6484C37.4604 30.6836 48.4609 45.5547 70.5 45.9902C92.5391 45.5547 103.54 30.6836 107.601 14.6484C109.616 6.69336 116.094 0 124.302 0H140.5V58H70.5H0.5V0H16.6982Z" fill="#9485E9"/>
    </svg>
</div>

